import React from "react";
import { Button, Form, Modal } from "react-bootstrap";

interface ConfirmActionModalProps {
  show: boolean;
  title: string;
  message: string;
  confirmLabel: string;
  confirmVariant?: "primary" | "danger" | "success";
  submitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  inputLabel?: string;
  inputPlaceholder?: string;
  inputValue?: string;
  onInputChange?: (value: string) => void;
  inputRequired?: boolean;
}

const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  show,
  title,
  message,
  confirmLabel,
  confirmVariant = "primary",
  submitting,
  onConfirm,
  onCancel,
  inputLabel,
  inputPlaceholder,
  inputValue,
  onInputChange,
  inputRequired = false,
}) => {
  const confirmDisabled = submitting || (inputRequired && !inputValue?.trim());

  return (
    <Modal show={show} onHide={onCancel} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: "1rem", fontWeight: 600 }}>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p style={{ marginBottom: inputLabel ? "1rem" : 0, fontSize: "0.9rem", color: "#555" }}>
          {message}
        </p>
        {inputLabel && onInputChange !== undefined && (
          <Form.Group>
            <Form.Label style={{ fontSize: "0.875rem", fontWeight: 500 }}>
              {inputLabel}
              {inputRequired && <span style={{ color: "#ef4444", marginLeft: 2 }}>*</span>}
            </Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder={inputPlaceholder}
              value={inputValue ?? ""}
              onChange={(e) => onInputChange(e.target.value)}
              disabled={submitting}
              style={{ fontSize: "0.875rem", resize: "vertical" }}
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="outline-secondary" onClick={onCancel} disabled={submitting}>
          Cancel
        </Button>
        <Button
          variant={confirmVariant}
          onClick={onConfirm}
          disabled={confirmDisabled}
        >
          {submitting ? "Processing…" : confirmLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmActionModal;
